export default __webpack_public_path__ + "static/hal-cruttenden-81f571c3d2a085f44d2cf4adcaff6e7e.png";